import { Link } from 'react-router';
import { FETCH_TODAY_JOBS_ACTION } from '~/actions';
import { OutlineChevronRightIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { Box, Column } from '~/commonComponents';
import { Table } from '~/components/JobList/TodayJobs/Table';
import { useLoading } from '~/hooks';
import { useAppSelector } from '~/hooks/useAppSelector';
import { Colors } from '~/themes/colors';

const LIMIT = 5;

export const TodayShiftsTab = () => {
  const { isLoading } = useLoading([FETCH_TODAY_JOBS_ACTION]);
  const isEmpty = useAppSelector((state) => state.job.todayJobs?.length === 0);

  return (
    <Column data-cy="todays-shifts-content">
      <Table limit={LIMIT} />
      {!isLoading && !isEmpty && (
        <Box alignItems="flex-end">
          <Link
            to="/dashboard/jobs/today"
            style={{
              textDecoration: 'none',
              cursor: 'pointer',
              marginRight: 12,
              marginBlock: 30,
            }}
            data-cy="view-all-shifts-link"
          >
            <div style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
              <span
                style={{
                  fontFamily: 'Nunito',
                  fontStyle: 'normal',
                  fontWeight: '700',
                  fontSize: 18,
                  color: Colors.secondary_500,
                }}
              >
                View All
              </span>
              <OutlineChevronRightIcon size={24} color={colors.secondary[500]} />
            </div>
          </Link>
        </Box>
      )}
    </Column>
  );
};
